import styled, { css } from 'styled-components';

export const Container = styled.div<{ $visualizacaoWebView: boolean }>`
  display: flex;
  flex-direction: column;
  flex: 1;

  padding-right: ${({ theme }) => theme.spacing[5]}px;
  padding-left: ${({ theme }) => theme.spacing[5]}px;
  gap: ${({ theme }) => theme.spacing[2]}px;

  background-color: ${({ theme }) => theme.panel.solid};

  ${({ theme, $visualizacaoWebView }) => {
    if (!$visualizacaoWebView) return '';
    return css`
      padding-top: ${theme.spacing[5]}px;
    `;
  }}
`;
